import { render, staticRenderFns } from "./ProductSubProducts.vue?vue&type=template&id=4d48a290&"
import script from "./ProductSubProducts.vue?vue&type=script&lang=js&"
export * from "./ProductSubProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports